declare global {
    interface Window {
        dataLayer: any[] | undefined
    }
}

const defaultData = {
    event: 'recobox',
    recobox_pagetype: 'modal_cart',
    recobox_boxName: 'mohlo_by_se_vam_hodit',
}

export const init = () => {
    window.dataLayer ??= []
    window.dataLayer.push({
        ...defaultData,
        recobox_action: 'impression',
    })
}

export const showProductDetail = (productCode: string) => {
    window.dataLayer ??= []
    window.dataLayer.push({
        ...defaultData,
        recobox_action: 'click_to_detail',
        recobox_product_id: productCode,
    })
}

export const addToCart = (productCode: string) => {
    window.dataLayer ??= []
    window.dataLayer.push({
        ...defaultData,
        recobox_action: 'add_to_cart',
        recobox_product_id: productCode,
    })
}
